import SalaForm from "./SalaForm";
export default SalaForm;
